(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

// legacy browser alert
function isLegacyIE() {
  var ua = navigator.userAgent;

  if (ua.indexOf("MSIE 6.0") != -1) {
    alert("お使いのウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
  } else if (ua.indexOf("MSIE 7.0") != -1) {
    alert("お使いのウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
  } else if (ua.indexOf("MSIE 8.0") != -1) {
    alert("お使いのウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
  } else if (ua.indexOf("MSIE 9.0") != -1) {
    alert("お使いのウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
  } else if (ua.indexOf("MSIE 10.0") != -1) {
    alert("お使いのウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
  } else {
    return false;
  }
}

isLegacyIE();
var loadingObject = document.getElementById('loading');

function fadeOutEffect(node, duration) {
  node.style.opacity = 1;
  var start = performance.now();
  requestAnimationFrame(function tick(timestamp) {
    var easing = (timestamp - start) / duration;
    node.style.opacity = Math.max(1 - easing, 0);

    if (easing < 1) {
      requestAnimationFrame(tick);
    } else {
      node.style.opacity = '';
      node.style.display = 'none';
    }
  });
}

function loadingAnimation() {
  fadeOutEffect(loadingObject, 1500);
}

function positionInitialize() {
  var viewportHeight = window.innerHeight;

  if (viewportHeight > 800) {
    window.scrollTo(0, viewportHeight);
  } else {
    window.scrollTo(0, 800);
  }
}

function firstViewAnimation() {
  var element = document.querySelectorAll('.mask_animation_onload');
  var elementArray = Array.prototype.slice.call(element);
  elementArray.forEach(function (items) {
    items.querySelector('.mask_inner').classList.add('start');
  });
}

function init() {
  Promise.resolve().then(function () {
    return new Promise(function (resolve) {
      setTimeout(function () {
        loadingAnimation();
        resolve();
      }, 2000);
    });
  }).then(function () {
    return new Promise(function (resolve) {
      positionInitialize();
      resolve();
    });
  }).then(function () {
    return new Promise(function (resolve) {
      setTimeout(function () {
        firstViewAnimation();
        resolve();
      }, 2000);
    });
  });
} // loading initialize


window.addEventListener("load", function () {
  init();
}); // mask animation with scroll

window.addEventListener("scroll", function () {
  var element = document.querySelectorAll('.mask_animation_onscroll');
  var elementArray = Array.prototype.slice.call(element);
  var scrollCount = document.documentElement.scrollTop || document.body.scrollTop;
  var windowHeight = window.innerHeight;
  var threshold = 100;
  elementArray.forEach(function (items) {
    var elementOffsetTop = items.getBoundingClientRect().top;
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var offsetPosition = elementOffsetTop + scrollTop;

    if (scrollCount > offsetPosition - windowHeight + threshold) {
      items.querySelector('.mask_inner').classList.add('start');
    }
  });
}); // fade in animation with scroll

window.addEventListener("scroll", function () {
  var element = document.querySelectorAll('.fade_in');
  var elementArray = Array.prototype.slice.call(element);
  var scrollCount = document.documentElement.scrollTop || document.body.scrollTop;
  var windowHeight = window.innerHeight;
  var threshold = 100;
  elementArray.forEach(function (items, index) {
    var elementOffsetTop = items.getBoundingClientRect().top;
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var offsetPosition = elementOffsetTop + scrollTop;
    var delay = 200 * index;

    if (scrollCount > offsetPosition - windowHeight + threshold) {
      setTimeout(function () {
        items.classList.add('__show');
      }, delay);
    }
  });
});
$(function () {
  // smooth scroll
  $('a[href*="#"].smooth_scroll').on('click', function () {
    var speed = 400;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $('body,html').animate({
      scrollTop: position
    }, speed, 'swing');
    return false;
  });
}); // contents navigation

$(window).on('load resize', function () {
  var position_01 = 0;
  var position_02 = Math.round($("#section_70th").offset().top);
  var position_03 = Math.round($("#section_history").offset().top);
  var position_04 = Math.round($("#section_message").offset().top) - 1;
  $(window).on('load resize scroll', function () {
    var startPosition = 0;
    var scrollPosition = $(window).scrollTop();
    var threshold = 200;

    if (position_01 <= scrollPosition && scrollPosition < position_02) {
      $("#scroll_guide_marker li").removeClass('__current');
      $("#scroll_guide_marker_item_01").addClass('__current');
    } else if (position_02 <= scrollPosition && scrollPosition < position_03) {
      $("#scroll_guide_marker li").removeClass('__current');
      $("#scroll_guide_marker_item_02").addClass('__current');
    } else if (position_03 <= scrollPosition && scrollPosition < position_04) {
      $("#scroll_guide_marker li").removeClass('__current');
      $("#scroll_guide_marker_item_03").addClass('__current');
    } else if (position_04 <= scrollPosition) {
      $("#scroll_guide_marker li").removeClass('__current');
      $("#scroll_guide_marker_item_04").addClass('__current');
    }
  });
});

},{}]},{},[1]);
